<ng-container *ngIf="provider && (provider.hidden || provider.deleted)">
    <ng-container *ngIf="provider.deleted; then deletedIcon else hiddenIcon" ></ng-container>
    <ng-template #deletedIcon><mat-icon [matTooltip]="'Api.ProviderProfile.Deleted_Profile' | translate">save</mat-icon></ng-template>
    <ng-template #hiddenIcon><mat-icon [matTooltip]="'Api.ProviderProfile.Profile_Not_Visible' | translate">visibility_off</mat-icon></ng-template>
</ng-container>
